import { Sentry, SentryTeam } from 'lib-shared-sentry';
import { Channel } from 'lib-shared-types-channels';

import { channelAttributes } from 'utils/channels';

import { useConversationRow } from '../../../utils/useConversationRow';

const getChannelName = (channel: Channel): string => {
  // if channel is not defined, return 'Unknown'
  if (!channel) {
    return 'Unknown';
  }
  // if channel is not in channelAttributes, return 'Unknown' and log error
  if (!channelAttributes[channel]) {
    Sentry.captureMessage(`Unknown conversation channel detected: ${channel}`, {
      level: 'error',
      tags: {
        team: SentryTeam.Conversations,
      },
      extra: {
        channel,
      },
    });
    return 'Unknown';
  }

  return channelAttributes[channel].name;
};

/** Represents the content of the channel cell in the conversations table. */
export const ConversationsTableChannel = (): JSX.Element => {
  const { conversation } = useConversationRow();

  const channelName = getChannelName(conversation.initial_channel);

  return <>{channelName}</>;
};
